module.exports = __webpack_public_path__ + "img/working.493973c4.jpg";